<!--
  Atlas has no top bar and no list (as Notes, #1016): the page starts at y = 0. The rail is the fixed
  collapsible column; the rest is the lazy Atlas page, rendered into the outlet. No `app-nav-bar`, no
  `app-base-nav-bar`, and no `app-split-view` wrapping the rail — it is a fixed column, not a pane.

  `[withSearch]="false"` is explicit: the rail's search input defaults ON, and Atlas's search is its
  own surface (A6), not the shared list search.
-->
<div class="atlas-shell">
  <div class="atlas-rest">
    <router-outlet />
  </div>
</div>
